import React from 'react';
import { FaShoppingCart } from 'react-icons/fa';

const CartIcon = ({ itemCount = 0 }) => {
    return (
        <>
            <FaShoppingCart className="cart-icon" />
            {itemCount > 0 && <span className="cart-count">{itemCount}</span>}
        </>
    );
};

export default CartIcon;